/**
 * LoadingSpinner / ButtonSpinner
 *
 * Page-centered spinner and a compact button-sized spinner. Includes presets
 * for reuse.
 */
import React from 'react';

export function LoadingSpinner({ message = 'Loading...' }) {
  return (
    <div className="flex h-[calc(100vh-16rem)] items-center justify-center">
      <div className="flex flex-col items-center gap-4">
        <div className="relative h-10 w-10">
          <div className="absolute inset-0 rounded-full border-2 border-gray-200 dark:border-gray-800" />
          <div className="absolute inset-0 rounded-full border-2 border-transparent border-t-primary-600 dark:border-t-primary-400 animate-spin" />
        </div>
        <p className="text-base font-medium text-gray-900 dark:text-white">
          {message}
        </p>
      </div>
    </div>
  );
}

// Add the ButtonSpinner component
export function ButtonSpinner({ color = "white", className = "" }) {
  return (
    <div 
      className={`inline-block h-4 w-4 -ml-1 mr-2 rounded-full border-2 border-${color} border-t-transparent animate-[spin_0.7s_linear_infinite] ${className}`}
      style={{ animation: 'spin 0.7s linear infinite' }}
    ></div>
  );
}

// Export an object with various spinner sizes and colors for reuse across the app
export const Spinners = {
  // Button-sized spinner with white color for dark backgrounds
  buttonWhite: <ButtonSpinner color="white" />,
  
  // Button-sized spinner with primary color for light backgrounds
  buttonPrimary: <ButtonSpinner color="primary-700 dark:primary-400" />,
  
  // Button-sized spinner with current text color
  buttonCurrent: <ButtonSpinner color="current" />,
  
  // Custom spinner function that takes size and color
  custom: (size = "h-4 w-4", color = "current") => (
    <div 
      className={`inline-block ${size} rounded-full border-2 border-${color} border-t-transparent animate-[spin_0.7s_linear_infinite]`}
      style={{ animation: 'spin 0.7s linear infinite' }}
    ></div>
  )
};